import React from 'react';

import {
  ClientDashboardGhostGapBars,
  ClientDashboardGhostGauge,
  ClientDashboardGhostRadar,
  ClientDashboardGhostWordCloud,
} from './ClientDashboardChartGhosts';

export function ClientDashboardPreviewPlaceholder() {
  return (
    <section
      className="client-dash__analytics-bento client-dash__analytics-bento--preview"
      aria-labelledby="client-dash-preview-title"
    >
      <header className="client-dash__analytics-bento-head">
        <h2 id="client-dash-preview-title" className="client-dash__analytics-bento-title">
          What appears here after your assessment
        </h2>
        <p className="client-dash__analytics-bento-lead">
          Maturity score, capability comparison, gaps, and themes from your responses — then
          expert review and your report.
        </p>
      </header>

      <div className="client-dash__analytics-bento-grid">
        <article
          className="client-dash__analytics-card client-dash__analytics-card--preview client-dash__analytics-card--gauge"
        >
          <h3 className="client-dash__analytics-card-title">Overall maturity score</h3>
          <ClientDashboardGhostGauge className="client-dash__chart-ghost client-dash__chart-ghost--gauge" />
        </article>

        <article
          className="client-dash__analytics-card client-dash__analytics-card--preview client-dash__analytics-card--gaps"
        >
          <h3 className="client-dash__analytics-card-title">Biggest gaps &amp; recommendations</h3>
          <ClientDashboardGhostGapBars className="client-dash__chart-ghost client-dash__chart-ghost--bars" />
        </article>

        <article
          className="client-dash__analytics-card client-dash__analytics-card--preview client-dash__analytics-card--radar"
        >
          <h3 className="client-dash__analytics-card-title">Current vs. target by capability</h3>
          <ClientDashboardGhostRadar className="client-dash__chart-ghost client-dash__chart-ghost--radar" />
        </article>

        <article
          className="client-dash__analytics-card client-dash__analytics-card--preview client-dash__analytics-card--cloud"
        >
          <h3 className="client-dash__analytics-card-title">Themes from your narrative</h3>
          <ClientDashboardGhostWordCloud className="client-dash__chart-ghost client-dash__chart-ghost--cloud" />
        </article>
      </div>
    </section>
  );
}

export default ClientDashboardPreviewPlaceholder;
